/**
 * AvatarUpload hook
 * - Double-click on the avatar area triggers the hidden file input
 * - When a file is selected, shows an instant local preview via createObjectURL
 * - Uses querySelector instead of getElementById for reliability with LiveView uploads
 */
export default {
  mounted() {
    this._previewUrl = null
    this._setup()
  },

  updated() {
    this._teardown()
    this._setup()
  },

  destroyed() {
    this._teardown()
    if (this._previewUrl) {
      URL.revokeObjectURL(this._previewUrl)
      this._previewUrl = null
    }
  },

  _input() {
    // Use querySelector scoped to this element — do NOT rely on id,
    // since LiveView may modify the id attr on live_file_input.
    return this.el.querySelector('input[type="file"]')
  },

  _setup() {
    const input = this._input()
    if (!input) return

    // Single-click anywhere in the zone (except cancel buttons) opens picker
    this._clickHandler = (e) => {
      if (e.target.closest("[data-avatar-cancel]")) return
      e.preventDefault()
      input.click()
    }
    const trigger = this.el.querySelector("[data-avatar-trigger]")
    if (trigger) {
      trigger.addEventListener("click", this._clickHandler)
    }

    // Show local preview immediately when file is picked
    this._changeHandler = (e) => {
      const file = e.target.files[0]
      if (!file) return

      if (this._previewUrl) URL.revokeObjectURL(this._previewUrl)
      this._previewUrl = URL.createObjectURL(file)

      let preview = this.el.querySelector("[data-avatar-preview]")
      const placeholder = this.el.querySelector("[data-avatar-placeholder]")

      if (preview) {
        preview.src = this._previewUrl
      } else {
        // No img yet (placeholder visible) — create one in place
        const img = document.createElement("img")
        img.src = this._previewUrl
        img.alt = "Avatar preview"
        img.dataset.avatarPreview = ""
        img.className = (placeholder && placeholder.className) ||
          "w-20 h-20 rounded-xl object-cover border border-gray-200"

        const trigger = this.el.querySelector("[data-avatar-trigger]")
        if (trigger) trigger.insertBefore(img, trigger.firstChild)
      }

      if (placeholder) placeholder.style.display = "none"
    }
    input.addEventListener("change", this._changeHandler)
  },

  _teardown() {
    const trigger = this.el.querySelector("[data-avatar-trigger]")
    if (trigger && this._clickHandler) {
      trigger.removeEventListener("click", this._clickHandler)
      this._clickHandler = null
    }
    const input = this._input()
    if (input && this._changeHandler) {
      input.removeEventListener("change", this._changeHandler)
      this._changeHandler = null
    }
  }
}
